import { GET_USER_WALLET_REQUEST, GET_USER_WALLET_SUCCESS, GET_USER_WALLET_ERROR, } from '../types';
import { useHelper } from '../helpers';
export const getUserWalletRequest = () => {
    return {
        type: GET_USER_WALLET_REQUEST,
    };
};
export const getUserWalletSuccess = () => {
    return {
        type: GET_USER_WALLET_SUCCESS,
    };
};
export const getUserWalletError = (error) => {
    return {
        type: GET_USER_WALLET_ERROR,
        error: true,
        payload: error,
    };
};
export const getUserWallet = () => {
    return async (dispatch, getState, { chord }) => {
        const { withAuth } = useHelper(dispatch, getState);
        try {
            dispatch(getUserWalletRequest());
            const wallet = await withAuth(chord.oms.getUserWallet)();
            dispatch(getUserWalletSuccess());
            return wallet.walletPaymentSources;
        }
        catch (error) {
            dispatch(getUserWalletError(error));
            throw error;
        }
    };
};
